

/**
 * @classdesc GIA
 * @kind class
 * @export
 * @prop {boolean} propose - Propose la GIA
 * @prop {boolean} selected - Selectionne la GIA
 * @prop {int} prix - Prix de la GIA
 * @class GIA
 */
export default class GIA {
    propose = false;
    selected = false;
    prix = 0;

    /**
     * Creates an instance of GIA.
     * @constructs
     * @kind function
     * @memberof GIA
     */
    constructor() { }

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }
    set_propose(propose) {
        this.propose = propose == "1";
    }

    set_prix(prix) {
        if (prix < 10) {
            this.propose = false;
        }
        let res = (parseFloat(prix) * 20) / 100;
        this.prix = res;
        this.update_cart();
    }

    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.selected && this.propose) {
            cart.prix = this.prix;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;



    }

    getLyraCommandeInfos() {
        if (!this.propose || !this.selected) return null;
        let infos = {
            prix: this?.cart?.prix,
        }
        return infos;
    }




}